import classNames from 'classnames';

import { getPropsFromModel, getComponentFromProps } from '../../../utils/use-child-components';
import { ContainerBackgroundClass } from '../../../utils/use-has-background-class';
import { ColumnContentGrid } from './column-content-grid';
import { ColumnContentContainerProps, ColumnContentTypes } from './column-content-container.config';
import { useDragComponentsPlaceholder } from '../../../utils/use-drag-components-placeholder';

const ColumnContentContainer = ({
  additionalClasses,
  appliedCssClassNames,
  cqItems,
  cqItemsOrder,
  cqPath,
  isInEditor,
  type,
  accessibilityLabel,
  id,
  roleAttribute,
}: ColumnContentContainerProps) => {
  const { placeholder } = useDragComponentsPlaceholder({ cqPath, isInEditor });
  const hasGradientBackground = appliedCssClassNames?.includes(ContainerBackgroundClass.GRADIENT);

  return (
    <div
      aria-label={accessibilityLabel}
      className={classNames('snowflake-column-content-container', additionalClasses)}
      data-testid="snowflake-column-content-container"
      id={id}
      role={roleAttribute}
    >
      {type === ColumnContentTypes.ONE_COLUMN && (
        <div>
          {cqItemsOrder?.map((key) => {
            const block = cqItems[key];
            const oneColumnProps = getPropsFromModel(block, cqPath, key);
            const OneColumn = getComponentFromProps(oneColumnProps);

            return OneColumn ? (
              <OneColumn
                key={key}
                {...oneColumnProps}
                appliedCssClassNames={classNames(
                  appliedCssClassNames,
                  oneColumnProps?.appliedCssClassNames,
                  'snowflake-column-content-container-item'
                )}
              />
            ) : null;
          })}
        </div>
      )}
      {type !== ColumnContentTypes.ONE_COLUMN && (
        <div data-testid="snowflake-column-container-multi-column">
          <ColumnContentGrid
            items={cqItems}
            itemsOrder={cqItemsOrder}
            columnContentType={type}
            cqPath={cqPath}
            hasGradientBackground={hasGradientBackground}
          />
        </div>
      )}
      {placeholder}
    </div>
  );
};

export default ColumnContentContainer;
